"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavigationProps = void 0;
const tslib_1 = require("tslib");
const react_router_dom_1 = require("react-router-dom");
const ArgusUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/ArgusUtils"));
const getNavigationProps = (href, variant) => {
    switch (variant) {
        case "internal":
        case "internal-refresh":
            // Eg: "/spa/sample/" => [ "", "spa", "sample", "" ] => "sample"
            const currentSpa = window?.location?.pathname?.split("/")?.[2];
            // Eg "sample/search/criteria" => "sample"
            const hrefSpa = href?.split("/")?.[0];
            // Check if the href point to the same SPA as the current window.location.pathname
            if (currentSpa === hrefSpa && variant === "internal") {
                return {
                    component: react_router_dom_1.NavLink,
                    // Remove first path specification, eg: sample/search/criteria => search/criteria
                    to: href?.split("/")?.slice(1)?.join("/"),
                };
            }
            //If the href points to a different SPA, use a normal anchor
            return {
                component: "a",
                href: ArgusUtils.toSpaUrl(href),
            };
        case "external":
        default:
            return {
                component: "a",
                href,
                target: "_blank",
                rel: "noopener noreferrer",
            };
    }
};
exports.getNavigationProps = getNavigationProps;
